export class ConfigGeoRegions
{
    /**
     * Regions by country for dropdowns.
     * @type {{country: string, regions: string[]}[]}
     */
    public static RegionsByCountry: {
        country: string,
        regions: {
            countryCode: string,
            region: string
        }[]
    }[] = [
        {
            country: 'U.S.',
            regions: [
                {countryCode: 'US', region: 'Alabama'},
                {countryCode: 'US', region: 'Alaska'},
                {countryCode: 'US', region: 'Arizona'},
                {countryCode: 'US', region: 'Arkansas'},
                {countryCode: 'US', region: 'California'},
                {countryCode: 'US', region: 'Colorado'},
                {countryCode: 'US', region: 'Connecticut'},
                {countryCode: 'US', region: 'Delaware'},
                {countryCode: 'US', region: 'Florida'},
                {countryCode: 'US', region: 'Georgia'},
                {countryCode: 'US', region: 'Hawaii'},
                {countryCode: 'US', region: 'Idaho'},
                {countryCode: 'US', region: 'Illinois'},
                {countryCode: 'US', region: 'Indiana'},
                {countryCode: 'US', region: 'Iowa'},
                {countryCode: 'US', region: 'Kansas'},
                {countryCode: 'US', region: 'Kentucky'},
                {countryCode: 'US', region: 'Louisiana'},
                {countryCode: 'US', region: 'Maine'},
                {countryCode: 'US', region: 'Maryland'},
                {countryCode: 'US', region: 'Massachusetts'},
                {countryCode: 'US', region: 'Michigan'},
                {countryCode: 'US', region: 'Minnesota'},
                {countryCode: 'US', region: 'Mississippi'},
                {countryCode: 'US', region: 'Missouri'},
                {countryCode: 'US', region: 'Montana'},
                {countryCode: 'US', region: 'Nebraska'},
                {countryCode: 'US', region: 'Nevada'},
                {countryCode: 'US', region: 'New Hampshire'},
                {countryCode: 'US', region: 'New Jersey'},
                {countryCode: 'US', region: 'New Mexico'},
                {countryCode: 'US', region: 'New York'},
                {countryCode: 'US', region: 'North Carolina'},
                {countryCode: 'US', region: 'North Dakota'},
                {countryCode: 'US', region: 'Ohio'},
                {countryCode: 'US', region: 'Oklahoma'},
                {countryCode: 'US', region: 'Oregon'},
                {countryCode: 'US', region: 'Pennsylvania'},
                {countryCode: 'US', region: 'Rhode Island'},
                {countryCode: 'US', region: 'South Carolina'},
                {countryCode: 'US', region: 'South Dakota'},
                {countryCode: 'US', region: 'Tennessee'},
                {countryCode: 'US', region: 'Texas'},
                {countryCode: 'US', region: 'Utah'},
                {countryCode: 'US', region: 'Vermont'},
                {countryCode: 'US', region: 'Virginia'},
                {countryCode: 'US', region: 'Washington'},
                {countryCode: 'US', region: 'West Virginia'},
                {countryCode: 'US', region: 'Wisconsin'},
                {countryCode: 'US', region: 'Wyoming'},

                {countryCode: 'US', region: 'District of Columbia'},
                {countryCode: 'US', region: 'American Samoa'},
                {countryCode: 'US', region: 'Federated States of Micronesia'},
                {countryCode: 'US', region: 'Guam'},
                {countryCode: 'US', region: 'Northern Mariana Islands'},
                {countryCode: 'US', region: 'Puerto Rico'},
                {countryCode: 'US', region: 'U.S. Virgin Islands'},
            ],
        },
        {
            country: 'Canada',
            regions: [
                {countryCode: 'CA', region: 'Alberta'},
                {countryCode: 'CA', region: 'British Columbia'},
                {countryCode: 'CA', region: 'Manitoba'},
                {countryCode: 'CA', region: 'New Brunswick'},
                {countryCode: 'CA', region: 'Newfoundland and Labrador'},
                {countryCode: 'CA', region: 'Northwest Territories'},
                {countryCode: 'CA', region: 'Nova Scotia'},
                {countryCode: 'CA', region: 'Nunavut'},
                {countryCode: 'CA', region: 'Ontario'},
                {countryCode: 'CA', region: 'Prince Edward Island'},
                {countryCode: 'CA', region: 'Quebec'},
                {countryCode: 'CA', region: 'Saskatchewan'},
                {countryCode: 'CA', region: 'Yukon'},
            ],
        },
        {
            country: 'Costa Rica',
            regions: [
                {countryCode: 'CR', region: 'Alajuela'},
                {countryCode: 'CR', region: 'Cartago'},
                {countryCode: 'CR', region: 'Guanacaste'},
                {countryCode: 'CR', region: 'Limon'},
                {countryCode: 'CR', region: 'Puntarenas'},
                {countryCode: 'CR', region: 'San Jose'},
            ],
        },
    ];

    /**
     * @param {{countryCode: string, region: string}} region
     * @returns {{countryCode: string, region: string}}
     */
    public static findRegion(region: { countryCode: string, region: string }): { countryCode: string, region: string } {
        for (let c: number = 0; c < ConfigGeoRegions.RegionsByCountry.length; c++) {
            if (ConfigGeoRegions.RegionsByCountry[c].regions[0].countryCode !== region.countryCode) {
                continue;
            }
            for (let r: number = 0; r < ConfigGeoRegions.RegionsByCountry[c].regions.length; r++) {
                if (ConfigGeoRegions.RegionsByCountry[c].regions[r].region === region.region) {
                    return ConfigGeoRegions.RegionsByCountry[c].regions[r];
                }
            }
        }

        return null;
    }
}
